import React from 'react';
import PropTypes from 'prop-types';
import { StatusDot, DotLegendContainer } from './TrainingList.styles';

const DotLegend = ({ searchTerm, setSearchTerm }) => {
  const styles = {
    display: 'flex',
    gap: '1rem',
    // justifyContent: 'center',
    // border: ' 1px solid orange',
  };
  const stylesY = {
    display: 'flex',
    gap: '1rem',
    maxHeight: '25px',
    // border: ' 1px solid blue',
  };
  return (
    <DotLegendContainer>
      <div style={{ width: '50%' }}>
        <input
          type="text"
          placeholder="Search users..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div style={stylesY}>
        <div style={styles}>
          <StatusDot status="expired" />{' '}
          <div>
            <p>Expired</p>
          </div>
        </div>
        <div style={styles}>
          <StatusDot status="in-progress" /> <p>In Progress</p>
        </div>
        <div style={styles}>
          <StatusDot status="completed" /> <p>Completed</p>
        </div>
      </div>
    </DotLegendContainer>
  );
};
DotLegend.propTypes = {
  searchTerm: PropTypes.string,
  setSearchTerm: PropTypes.func,
};
export default DotLegend;
